import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css'],
})
export class AboutusComponent implements OnInit, AfterViewInit {
  panelOpenState: { [key: string]: boolean } = {};
  offers = [
    {
      value: 1,
      heading: 'Digital Strategy & Consulting',
      sub_heading: 'Custom strategies tailored to your business goals.',
    },
    {
      value: 2,
      heading: 'Social Media Management',
      sub_heading: 'End-to-end management of your online presence across platforms.',
    },
    {
      value: 3,
      heading: 'Content Creation & Marketing',
      sub_heading:
        'From engaging posts to visually appealing carousels and reels, we create content that speaks to your audience.',
    },
    {
      value: 4,
      heading: 'AI-Driven Marketing',
      sub_heading:
        'Automated campaigns and AI-powered tools to boost efficiency and performance.',
    },
    {
      value: 5,
      heading: 'Brand Management',
      sub_heading:
        "Building and managing your brand's reputation with the best practices in the industry.",
    },
  ];

  cards = [
    {
      image: '/assets/about_us/super_fast.png',
      heading: 'Super fast delivery',
      description:
        'Super fast delivery of our services ensures clients receive timely and efficient solutions, enhancing their experience and satisfaction.',
    },
    {
      image: '/assets/about_us/hands.png',
      heading: 'Customized services',
      description:
        'Customized services in a diverse marketplace help businesses meet individual client needs, fostering stronger connections and enhancing customer satisfaction and loyalty.',
    },
    {
      image: '/assets/about_us/artificial-intelligence.png',
      heading: 'Impressive technology innovation',
      description:
        'Technological innovations are revolutionizing industries by boosting efficiency, fostering new opportunities, and enhancing user experiences, paving the way for future advancements.',
    },
    {
      image: '/assets/about_us/rating.png',
      heading: 'Customer oriented approach',
      description:
        'A customer-oriented approach focuses on understanding and meeting the specific needs and preferences of customers to enhance their satisfaction and loyalty.',
    },
  ];

  constructor(private titleService: Title) {}

  togglePanel(panel: string): void {
    this.panelOpenState[panel] = !this.panelOpenState[panel];
  }

  ngOnInit(): void {
    this.titleService.setTitle('About Us');
  }

  ngAfterViewInit(): void {
    this.initScrollAnimations();
  }

  private initScrollAnimations(): void {
    // Smooth scroll to specific section
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: '#about_us_section', autoKill: true },
      ease: 'power3.out',
    });

    // Section-based scroll animations
    gsap.from('.section-intro', {
      y: 100,
      opacity: 0,
      duration: 1.5,
      scrollTrigger: {
        trigger: '.section-intro',
        start: 'top bottom',
        end: 'top center',
        scrub: true,
      },
    });

    gsap.from('.section-what-we-do', {
      x: -100,
      opacity: 0,
      duration: 1.5,
      scrollTrigger: {
        trigger: '.section-what-we-do',
        start: 'top bottom',
        end: 'top center',
        scrub: true,
      },
    });

    gsap.from('.section-team', {
      x: 100,
      opacity: 0,
      duration: 1.5,
      scrollTrigger: {
        trigger: '.section-team',
        start: 'top bottom',
        end: 'top center',
        scrub: true,
      },
    });

    // Animate offer cards
    gsap.from('.card_design', {
      scale: 0.9,
      opacity: 0,
      duration: 1.5,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.card_design',
        start: 'top bottom',
        end: 'top center',
        scrub: true,
      },
    });

    // Animate sections with the class `.about_us_data`
   const sections = gsap.utils.toArray('.about_us_data') as HTMLElement[];

sections.forEach((section) => {
  gsap.from(section, {
    opacity: 0,
    y: 50,
    duration: 1.5,
    scrollTrigger: {
      trigger: section,
      start: 'top bottom',
      end: 'top center',
      scrub: true,
    },
  });
});

  }
}
